import { useAuthStatusQuery } from '../queries/auth'
import { AuthStatusResponse } from '../models/AuthStatusResponse'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AuthService } from '../services/AuthService'
import { useNavigate } from '@tanstack/react-router'

/**
 * useAuth フック
 * useAuthStatusQuery を利用して認証状態とユーザー情報を返し、Tanstack Query の mutation でログアウト処理も扱います。
 */
export function useAuth() {
  const queryClient = useQueryClient()
  const { data, error } = useAuthStatusQuery()
  const navigate = useNavigate()

  // Tanstack Query の mutation を利用して /api/auth/logout を呼び出し、成功時にルートパスへ遷移します。
  const logoutMutation = useMutation({
    mutationFn: () => {
      return AuthService.logout()
    },
    onSuccess: () => {
      // キャッシュをクリアしてからルートパスへリダイレクト
      queryClient.clear()
      navigate({ to: '/' })
    },
    onError: (err: unknown) => {
      console.error('Logout error:', err)
    },
  })

  const isAuthenticated = data?.authenticated ?? false
  const user = data ? (data as AuthStatusResponse).user : null

  const logout = () => {
    return logoutMutation.mutate()
  }

  const login = () => {
    // Microsoft認証ページにリダイレクト(navigateは使用しない)
    // これはサーバーサイドで処理されるため、クライアント側のルーティングは不要
    window.location.href = '/api/auth/login'
  }

  return { isAuthenticated, user, logout,login }
}
